import React from 'react'

export default function TradingChartIcon({
  className = 'h-6 w-6 text-[#006400]',
}: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
      <rect x="3" y="8" width="2" height="8" rx="1" />
      <rect x="8" y="4" width="2" height="12" rx="1" />
      <rect x="13" y="10" width="2" height="6" rx="1" />
      <rect x="18" y="6" width="2" height="10" rx="1" />
      <path d="M4 6v2M9 2v2M14 8v2M19 4v2M4 16v2M9 16v4M14 16v2M19 16v2"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}
